import React, { useState, useEffect } from "react";
import DataServiceSQL from "../../DataService/DataServiceSQL";
import GatewayFunctionsGetter from '../../Controller/getSQLGatewayFunctions.js';
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import {FormattedMessage} from 'react-intl';

const Gateway = props => {
  const [currentGateway, setCurrentGateway] = useState({id_gw: -1, gw_name: 'TUCKY-GWxxxx', FK_structure: 0}); // TEMP : Sure ??
  const [submitted, setsubmitted] = useState(false);
  const [message, setmessage] = useState("");

  useEffect(() => {
    getGateway(props.id_gw, props.structure_Id);
  },
  //eslint-disable-next-line 
  [props.id_gw]);


  const getGateway = async (id_gw, structure_Id) => {
    let local_gateway = [];
    local_gateway = await GatewayFunctionsGetter.get_gateway_by_criteria("identifier", id_gw);
    if (local_gateway !== "none"){
      local_gateway = GatewayFunctionsGetter.convert_fhir_gateway(local_gateway);
      setCurrentGateway(local_gateway[0])
    }
  };

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentGateway({ ...currentGateway, [name]: value });
  };

  const updateGateway = () => {
    let gateway_data = {
      resourceType: "Device",
      type: "Gateway",
      name: currentGateway.nickname
    }
    DataServiceSQL.updateDeviceReq_fhir(currentGateway.id_gw, gateway_data)
      .then(response => {
        setmessage(<FormattedMessage id="message.success" defaultMessage="Success !" />);
        setsubmitted(true);
      })
      .catch(e => {
        setmessage(<FormattedMessage id="message.error.gw.up" defaultMessage="Oups, did not work... (gw_up)" />);
        setsubmitted(true);
      });
  };

  const { classes } = props;

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form">
          {(submitted) ? (
            <div>
              <center>
                <h4>{message}</h4>
                <button onClick={props.closeAfterEdit} className="btn btn-success">
                  <FormattedMessage id="button.close" defaultMessage="Close" />
                </button>
              </center>
            </div>
          ) 
          : 
          (
            <div>
              <center>
                <div>
                  <Row className="justify-content-md-end" style = {{ paddingBottom: "10px" }}>
                    <Col style={{ fontWeight: "bold", fontSize:"2.2em" }}>
                      <FormattedMessage id="gateway.edit" defaultMessage="Edit gateway" />
                    </Col>
                  </Row>
                </div>
                <br/>                                       
                <div className="form-group">
                  <label htmlFor="nickname">
                    <FormattedMessage id="gateway.nickname" defaultMessage="Nickname" />
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="nickname"
                    name="nickname"
                    value={currentGateway.nickname}
                    onChange={handleInputChange}
                  />
                </div>                                                          
                <br/>
                <button onClick={props.cancelPopup} className="btn btn-danger">
                  <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                </button>
                <b>&emsp;</b>
                <button onClick={updateGateway} className="btn btn-success">
                  <FormattedMessage id="button.submit" defaultMessage="Submit" />
                </button>
              </center>
            </div>
          )
        }
        </div>
      </div>
    </div>
  );
};

export default withStyles(Constants.styles)(Gateway);
